module.exports = __webpack_public_path__ + "assets/img/goddard.bf3e76f8.jpg";